import { io } from "socket.io-client";
// http://localhost:5000 https://api.monkeye.in
const socket = io("https://api.monkeye.in", {
 transports: ['polling', 'websocket'],
  withCredentials: true,
});


export default socket;
